<template>
  <div class="userWrap">
    <div class="loginWrap clearfix">
      <div class="loginLeft fl">
        <img class="bg1" src="~img/account/bg1.png" alt="" />
        <img
          @click="gohome"
          class="logotop"
          src="~img/account/logotop.png"
          alt=""
        />
        <div class="logoInfo">
          <img src="~img/account/email.png" alt="" />
          <p>kefu@yuanshixx.com</p>
          <img src="~img/account/phone2.png" alt="" />
          <p>010-82156292</p>
          <img src="~img/account/qq2.png" alt="" />
          <p>2984543729 / 2814551419</p>
        </div>
      </div>
      <div class="loginRight fl">
        <img class="bg2" src="~img/account/bg2.png" alt="" />
        <el-form
          class="loginall"
          ref="loginForm"
          :model="loginDate"
          :rules="rules"
        >
          <h2>登录</h2>
          <el-form-item prop="account" ref="account">
            <el-input
              v-model="loginDate.account"
              placeholder="用户名"
              @focus="getFocus('account')"
              class="login-form-input"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginDate.password"
              class="login-form-input"
              placeholder="密码"
              @focus="getFocus('password')"
              ref="password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item class="loginbtn">
            <el-button class="usersub" @click="submitLogin('loginForm')"
              >登录</el-button
            >
          </el-form-item>
          <el-form-item class="elseoption">
            <el-checkbox label="记住我" v-model="checked"></el-checkbox>
            <div class="goelse fr">
              <router-link to="/forget">忘记密码？</router-link>
              <!-- |
          <router-link to="/register">注册</router-link> -->
            </div>
          </el-form-item>
          <loginelse></loginelse>
        </el-form>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import {
  isMobile,
  isPwd,
  encryptStr,
  setCookie,
  getCookie,
  delCookie
} from "utils/core/kernel";
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (isMobile(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号"));
      }
    };
    var validatePass = (rule, value, callback) => {
      if (isPwd(value)) {
        callback();
      } else {
        callback(new Error("请输入6-20位字母大小写数字特殊符号"));
      }
    };
    return {
      loginDate: {
        account: "",
        password: ""
      },
      foucsitem: "", // 移除元素
      checked: true,
      rules: {
        account: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.$nextTick(() => {
      if (getCookie("psw")) {
        this.loginDate = {
          account: getCookie("account"),
          password: getCookie("psw")
        };
      }
    });
  },
  methods: {
    submitLogin(formname) {
      this.$refs[formname].validate(valid => {
        if (valid) {
          let data = this.qs.stringify({
            account: encryptStr(this.loginDate.account),
            password: encryptStr(this.loginDate.password)
          });
          this.$store
            .dispatch("Login", data)
            .then(res => {
              if (res.success) {
                if (this.checked) {
                  setCookie("account", this.loginDate.account, 7);
                  setCookie("psw", this.loginDate.password, 7);
                } else {
                  delCookie("account");
                  delCookie("psw");
                }
                if (this.$route.query.redirect) {
                  this.$router.replace(this.$route.query.redirect);
                } else {
                  this.$router.replace("/home");
                }
              } else {
                if (res.code == 20001) {
                  this.$router.replace("/home");
                }
              }
            })
            .catch(() => {});
        }
      });
    },
    // 移除
    getFocus(item) {
      this.$refs["loginForm"].clearValidate(item);
    },
    // 去首页
    gohome() {
      this.$router.push("/home");
    }
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta
    to.meta.keepAlive = false; // C 跳转到 A 时让 A 不缓存，即刷新
    next();
  },
  mounted() {}
};
</script>
<style lang="stylus" scoped></style>
